import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Bileşenler
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Sayfalar
import Home from './pages/Home';
import Projects from './pages/Projects';
import ExereyesHome from './pages/ExereyesHome';
import Contact from './pages/Contact';
import About from './pages/About';
import Features from './pages/Features';
import Privacy from './pages/Privacy';
import RemoveUser from './pages/RemoveUser';
import KVKK from './pages/KVKK';
import KVKKForm from './pages/KVKKForm';
import FAQ from './pages/FAQ';

// Sayfa değiştiğinde ekranı en yukarı kaydıran yardımcı bileşen
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Favicon'u sayfa değişikliğine göre güncelleyen bileşen
const FaviconUpdater = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Exereyes sayfalarında Exereyes logosunu kullan
    if (pathname.startsWith('/exereyes')) {
      updateFavicon('/exereyes_logo.jpg');
    } else {
      // Diğer sayfalarda Lotus Sport logosunu kullan
      updateFavicon('/lotus-sport-logo.jpg');
    }
  }, [pathname]);

  const updateFavicon = (iconPath: string) => {
    // Mevcut favicon linklerini bul ve güncelle
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = iconPath;
    link.type = 'image/jpeg';

    // Apple touch icon'u da güncelle
    let appleLink = document.querySelector("link[rel~='apple-touch-icon']") as HTMLLinkElement;
    if (!appleLink) {
      appleLink = document.createElement('link');
      appleLink.rel = 'apple-touch-icon';
      document.getElementsByTagName('head')[0].appendChild(appleLink);
    }
    appleLink.href = iconPath;
  };

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop /> {/* Sayfa geçişlerinde scroll'u sıfırlar */}
      <FaviconUpdater /> {/* Sayfa değişikliğine göre favicon'u günceller */}
      
      <div className="min-h-screen bg-white flex flex-col font-sans">
        <Navbar />
        
        {/* ÖNEMLİ: 'pt-20' sınıfı buradan kaldırıldı. 
          Böylece ExereyesHome sayfasındaki Hero görseli Navbar'ın arkasına geçebilir.
          
          NOT: Diğer sayfaların (Contact, About vb.) içeriğinin Navbar altında kalmaması için
          o sayfaların en dış kapsayıcısına 'pt-24' veya 'pt-32' eklemelisiniz.
        */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/exereyes" element={<ExereyesHome />} />
            <Route path="/exereyes/removeuser" element={<RemoveUser />} />
            <Route path="/about" element={<About />} />
            <Route path="/features" element={<Features />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/kvkk" element={<KVKK />} />
            <Route path="/kvkk/basvuru" element={<KVKKForm />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
};

export default App;
